import React, { useMemo } from 'react';
import SidebarMenu from './SidebarMenu';
import useMensajesNoLeidos from '../../../hooks/useMensajesNoLeidos';

const buildAlumnoMenuItems = () => ([
  { id: 'panel', label: 'Mi espacio', icon: 'fas fa-user-graduate', path: '/alumno/panel' },
  { id: 'mensajes', label: 'Mensajes', icon: 'fas fa-envelope', path: '/mensajes' }
]);

const AlumnoMenu = ({ activeId, onNavigate, className = '', messageScope = 'colegio' }) => {
  const { count: mensajesNoLeidos } = useMensajesNoLeidos(true, { scope: messageScope });
  const items = useMemo(() => buildAlumnoMenuItems().map((item) => (
    item.id === 'mensajes' ? { ...item, badge: mensajesNoLeidos } : item
  )), [mensajesNoLeidos]);

  return (
    <SidebarMenu
      items={items}
      activeId={activeId}
      onNavigate={onNavigate}
      className={className}
    />
  );
};

export { buildAlumnoMenuItems };
export default AlumnoMenu;
